<style scoped>
  .search >>> .ivu-input{width: 218px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 40px 0 12px;}
  .notice-background{background: url("/img/sys/bg1.png");height: 140px;}
  .search-click{background-color: #00a2e9;width: 28px;height: 28px;border-radius: 14px;position: absolute;top: 17px;text-align: center;left: 182px;cursor:pointer;}
</style>
<template>
  <div>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <Menu mode="horizontal" style="padding:0 40px" :active-name="$route.name">
      <MenuItem v-if="true" name="projectTask" :to="{name:'projectTask',query:{caseId:$route.query.caseId,taskId:$route.query.taskId,filed:$route.query.filed}}">
        <Icon type="ios-paper" />
        任务
      </MenuItem>
      <span v-else style="padding: 0 20px;color: #bbb;">
        <Icon type="ios-paper" />
        任务
      </span>
      <MenuItem v-if="true" name="projectApproval" :to="{name:'projectApproval',query:{caseId:$route.query.caseId,taskId:$route.query.taskId,filed:$route.query.filed}}">
        <Icon type="ios-create" />
        审批
      </MenuItem>
      <span v-else style="padding: 0 20px;color: #bbb;">
        <Icon type="ios-create" />
        审批
      </span>
      <MenuItem v-if="true" name="projectReceivables" :to="{name:'projectReceivables',query:{caseId:$route.query.caseId,taskId:$route.query.taskId,filed:$route.query.filed}}">
        <Icon type="ios-card" />
        财务
      </MenuItem>
      <span v-else style="padding: 0 20px;color: #bbb;">
        <Icon type="ios-card" />
        财务
      </span>
      <MenuItem v-if="true" name="projectSituation" :to="{name:'projectSituation',query:{caseId:$route.query.caseId,taskId:$route.query.taskId,filed:$route.query.filed}}">
        <Icon type="ios-filing-outline" />
        案情
      </MenuItem>
      <span v-else style="padding: 0 20px;color: #bbb;">
        <Icon type="ios-filing-outline" />
        案情
      </span>
      <MenuItem v-if="true" name="projectComment" :to="{name:'projectHistory',query:{caseId:$route.query.caseId,taskId:$route.query.taskId,filed:$route.query.filed}}">
        <Icon type="ios-people" />
        操作记录
      </MenuItem>
      <span v-else style="padding: 0 20px;color: #bbb;">
        <Icon type="ios-people" />
        操作记录
      </span>
      <!--<MenuItem name="projectStatistics" :to="{name:'projectStatistics',query:{caseId:$route.query.caseId,taskId:$route.query.taskId}}">-->
        <!--<Icon type="ios-stats" />-->
        <!--统计-->
      <!--</MenuItem>-->
      <MenuItem v-if="$route.query.filed!=1&&companyName=='云联'" name="projectSeal" :to="{name:'projectSeal',query:{caseId:$route.query.caseId,taskId:$route.query.taskId,filed:$route.query.filed}}">
        <Icon type="md-book" />
        合同签章
      </MenuItem>
      <MenuItem v-if="$route.query.filed!=1" name="projectSetting" :to="{name:'projectSetting',query:{caseId:$route.query.caseId,taskId:$route.query.taskId,filed:$route.query.filed}}">
        <Icon type="ios-options" />
        设置
      </MenuItem>
      <div style="position: relative;display: inline-block;float: right;">
        <Input class="search"  placeholder="搜索任务"></Input>
        <div class="search-click">
          <img style="margin-top: 6px;vertical-align: top;" src="/img/project/search-icon.png"/>
        </div>
      </div>
    </Menu>
    <router-view :projectData="projectData" style="padding:0 40px;background-color:white"></router-view>
  </div>
</template>

<script>
  export default {
    name: "detials",//案件详情
    data (){
      return {
        projectData:{},
      }
    },
    mounted : function () {
      this.projectRegister()
    },
    methods:{
      projectRegister: function () {
        var _this = this
        _this.send({
          headers: "E/ShowSingleCase",
          data: {
            CaseId: _this.$route.query.caseId
          },
          success: function (res) {
            _this.projectData = res
          }
        })
      },
    },
		computed:{
			companyName:function(){
				return companyName
			},
		},
  }
</script>
